
const state = {
    title: 'Fluxum' // use getCurrentLocale to get the correct locale
}


const actions = {
    setTitle({commit, state, dispatch}, title) {
        commit('updateTitle', title)
    }
}

const mutations = {
    updateTitle (state, title) {
        state.title = 'Fluxum | ' + title
        document.title = state.title
    },
    resetTitle(state, title) {
        state.title = 'Fluxum | '
        document.title = state.title
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
